document.addEventListener("DOMContentLoaded", () => {
    const copyBtn = document.getElementById("copy-link-btn");
    const copyLabel = document.getElementById("copy-link-label");
    if (!copyBtn || !copyLabel) return;

    const originalLabel = copyLabel.textContent;

    copyBtn.addEventListener("click", async () => {
        const url = copyBtn.dataset.shareUrl;

        try {
            await navigator.clipboard.writeText(url);
            copyLabel.textContent = "Copied!";
            setTimeout(() => {
                copyLabel.textContent = originalLabel;
            }, 2000);
        } catch (err) {
            console.error("Failed to copy link:", err);
        }
    });
});
